/* Unit-conversion constants for the /elcapp/newquote island -- extracted
   from newquote.js. */

const LBS_TO_KG = 0.453592;
const IN_TO_CM  = 2.54;
// Standard air-cargo volumetric divisor: 6000 cm³/kg.
const VOL_DIVISOR_CM = 6000;

// Chargeable-weight rule (2026-07): ceil to whole kg, rounding to 3dp first
// to shave float noise (2.9999999999999996 → 3, not 4). Mirrors the server's
// _ceil_kg in elcapp_pricing.py — every weight sent for pricing goes through
// this. NaN in → 0 out (callers treat 0 as "not a valid weight").
const ceilKg = (w) => Math.ceil(Math.round((Number(w) || 0) * 1000) / 1000);

export { LBS_TO_KG, IN_TO_CM, VOL_DIVISOR_CM, ceilKg };
